import React from 'react';
// Redux
import { useDispatch } from 'react-redux';
import { MenuFilters } from '../../../redux/types/filtersTypes';
import { setFilters, resetFilters } from '../../../redux/actions/FiltersActions';
// App
import DashboardComponent from '../../../components/DashboardComponent';
import MenusListComponent from '../../../components/Menus/MenusListComponent';
// Other
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';

export default function MenusRouting(props: RouteComponentProps) {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setFilters(new MenuFilters()));
    return () => {
      dispatch(resetFilters());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DashboardComponent
      title={<h2>Pruebas de Menu</h2>}
      children={<Switch>
        <Route exact path={props.match.path + '/list'} component={MenusListComponent} />
        <Redirect to={props.match.path + '/list'} />
      </Switch>}
    />
  );
}
